{
  "network": {
    "unexpected": "Произошла непредвиденная ошибка. Пожалуйста, попробуйте снова.",
    "connectionFailed": "Не удалось подключиться. Проверьте сеть.",
    "timeout": "Время ожидания истекло. Пожалуйста, попробуйте снова."
  },
  "auth": {
    "invalidCredentials": "Неверные данные. Проверьте адрес электронной почты и пароль.",
    "accountInactive": "Ваш аккаунт неактивен. Обратитесь к администратору.",
    "sessionExpired": "Сессия истекла. Пожалуйста, войдите снова."
  },
  "validation": {
    "required": "Это поле обязательно для заполнения.",
    "emailInvalid": "Введите корректный адрес электронной почты.",
    "passwordTooShort": "Пароль должен содержать не менее 8 символов.",
    "passwordMismatch": "Пароли не совпадают."
  },
  "actions": {
    "saveFailed": "Не удалось сохранить. Пожалуйста, попробуйте снова.",
    "deleteFailed": "Не удалось удалить. Пожалуйста, попробуйте снова.",
    "loadFailed": "Не удалось загрузить данные. Пожалуйста, попробуйте снова.",
    "exportFailed": "Не удалось экспортировать. Пожалуйста, попробуйте снова.",
    "importFailed": "Не удалось импортировать. Пожалуйста, попробуйте снова.",
    "uploadFailed": "Не удалось загрузить файл. Пожалуйста, попробуйте снова.",
    "copyFailed": "Не удалось скопировать в буфер обмена.",
    "resetFailed": "Не удалось сбросить. Пожалуйста, попробуйте снова.",
    "approveFailed": "Не удалось одобрить. Пожалуйста, попробуйте снова.",
    "rejectFailed": "Не удалось отклонить. Пожалуйста, попробуйте снова."
  }
}
